import React from 'react';
import { Link } from 'gatsby';
import classNames from 'classnames';

import Card from './Card/Card';

import css from './News.module.scss';

const News = ({ heading, data, seeAll, customClass }) => {
	return (
		<section className={classNames(css.news, css[customClass])}>
			<div className={css.heading}>
				{heading && <h2 data-aos="fade-up">{heading}</h2>}
				{seeAll && (
					<span className="showMobile" data-aos="fade-up">
						<Link to="/press" className="linkUnderline">
							See all
						</Link>
					</span>
				)}
			</div>
			<div className={css.cards}>
				{data.map(props => (
					<Card key={props.id} customClass={customClass} {...props} />
				))}
			</div>
			{seeAll && (
				<span className={`${css.seeAllLink} showDesktop`} data-aos="fade-up">
					<Link to="/press" className="linkUnderline">
						See all
					</Link>
				</span>
			)}
		</section>
	);
};

export default News;
